import MyPage from '../module/MyPage.js';
import Embed from '../module/Embed.js';

export default class Home extends MyPage {

	constructor() {

		super();

	}

	/*
	** init
	*/

	init() {

		// super
		super.init();

		// embed
		this.embed = new Embed();
		this.embed.load();

	}

	/*
	** unload
	*/

	unload() {

		// super
		super.unload();

		// embed
		if (this.embed)
		{
			this.embed.unload();
			this.embed = null;
		}

	}
}